import TagManager from "react-gtm-module";
import { logService } from "./logService";

class GtmService {
  public init(id: string) {
    TagManager.initialize({
      gtmId: id,
    });

    logService.info("GTM initiated with: ", id);
  }

  public event({ event, ...more }: { [key: string]: unknown; event: string }) {
    TagManager.dataLayer({
      dataLayer: { event: event, ...more },
    });

    logService.info("GTM action triggered:", event, more);
  }
}

export const gtmService = new GtmService();
